export enum EAnalyticsEventType {
	PAGE_VIEW = 'page_view',
	ADD_TO_WISHLIST = 'add_to_wishlist',
	VIEW_ITEM = 'view_item',
	VIEW_ITEM_LIST = 'view_item_list',
	ADD_TO_CART = 'add_to_cart',
	REMOVE_FROM_CART = 'remove_from_cart',
	SELECT_ITEM = 'select_item',
	SELECT_PROMOTION = 'select_promotion',
	VIEW_PROMOTION = 'view_promotion',
	SIGNUP = 'sign_up',
	NEWSLETTER_SUBSCRIPTION = 'newsletter_subscription',
	LOGS_IN = 'login',
	LOGS_OUT = 'logout',
	WISHLIST_UPDATED = 'wishlist_updated',
	CART_UPDATED = 'cart_updated',
}

export enum EAnalyticsEventSource {
	HOME = 'Homepage',
	PLP = 'ProductListPage',
	PDP = 'ProductPage',
	SP = 'SplashPage',
	CUSTOMER_SERVICE = 'Customer Service',
	OTHER = 'Other',
	SEARCH_RESULTS = 'search-results',
	SEARCH_PREVIEW = 'search-preview',
	FULL_SEARCH_RESULTS = 'full-search-results',
	YOU_MAY_ALSO_LIKE = 'you-may-also-like',
	WEAR_THIS_WITH = 'wear-this-with',
	RECENTLY_VIEWED = 'recently-viewed',
	RECOMMENDATION = 'recommendation',
	CART = 'cart',
	WISHLIST = 'wishlist',
	MY_ACCOUNT = 'My Account',
}
